import { InputMaybe } from 'src/generated/graphql';
import { Awards } from './award';
import { Scalars } from './scalars';
import { User } from './user';
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export class Buy {
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  createdAt: Scalars['String'];
  status: Scalars['String'];
  user: User;
  awards: Awards;
}
export interface CreateBuyMovMutation {
  createBuyMov: {
    employeeId: string;
    employee: {
      id: string;
      name: string;
    };
    phoneDelivery: String;
    buyItems: Array<{
      award: {
        id: string;
        name: string;
      };
    }>;
  };
}

export interface CreateBuyMovMutationVariables {
  createBuyMovDto: CreateBuyMovDto;
}

export interface CreateBuyMovDto {
  // Defina o formato dos dados que você está enviando com a mutação
  employeeId: string;
  phoneDelivery: string;
  items: Array<{
    awardId: string;
    quantity: number;
  }>;
}

// ------------------- GETALL
export type GetAllBuyQueryVariables = Exact<{
  keyword: Scalars['String'];
}>;

export type GetAllBuyQuery = { getAllBuy: Buy[] };

// ------------------- REMOVE
export class RemoveBuyInput {
  id: Scalars['ID'];
  role: Scalars['String'];
}
export type RemoveExchangesMutationVariable = Exact<{
  data: RemoveBuyInput;
}>;

export type RemoveExchangesMutation = {
  removeExchanges: { id: string; role: string };
};

// ------------------- CREATE
export type CreateExchangesMutationVariable = Exact<{
  data: Buy;
}>;

export type CreateExchangesMutation = {
  createBuy: {
    id: string;
    name: string;
    image: string;
    value: number;
    quantity: number;
  };
};

// ------------------- UPDATE
export class UpdateBuyInput {
  id: string;
  data: Buy;
}

export type UpdateBuyMutation = {
  updateBuy: { id: string };
};

export type UpdateBuyMutationVariable = Exact<{
  id: string;
  data: Buy;
}>;

export type UploadFileResponse = {
  fileName: string;
  requestId: string;
  eTag: string;
  versionId: string;
};

// ------------------- SEARCH
export type SearchBuyQuery = Exact<{ searchBuy: Buy[] }>;

export class SearchBuyInput {
  re?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}

export type SearchBuyQueryVariables = Exact<{
  input: SearchBuyInput;
}>;

export type SearchBuyProductQuery = Exact<{ searchBuyProduct: Buy[] }>;

export class SearchBuyProductInput {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
}

export type SearchBuyProductQueryVariables = Exact<{
  input: SearchBuyProductInput;
}>;
